import { render, staticRenderFns } from "./BusinessInformationSection.vue?vue&type=template&id=3981a35a&"
import script from "./BusinessInformationSection.vue?vue&type=script&lang=js&"
export * from "./BusinessInformationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports